module.exports = __webpack_public_path__ + "img/Patch2-20170705-2.3eb4f5cd.webp";